module.exports = __webpack_public_path__ + "static/media/team--sang.b68dd8c0.jpg";